import { css } from 'styled-components';

export default css`
  padding: 10px;
  width: 100%;

  .layout-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 150px));
    gap: 20px;

    & > * {
      cursor: pointer;
      border-radius: 8px;
      border: 1px solid var(--color-border-thumbnail);
      color: var(--color-text-thumbnail);

      box-shadow: var(--boxShadow-thumbnail);
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 10px;
      align-items: center;
      transition: all 0.3s;

      &:hover {
        border: 1px solid var(--color-border-thumbnail-hover);
        color: var(--color-text-thumbnail-hover);
        background-color: var(--color-background-thumbnail-hover);
      }

      .icon {
        font-size: 32px;
      }
    }
  }
`;
